import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from '@angular/common/http';
import { Observable, BehaviorSubject } from 'rxjs';
import { finalize } from 'rxjs/operators';

// Globális betöltés-állapot: hány /api kérés van épp folyamatban. A app.component egy felső
// töltősávot mutat, amíg active$ = true. Így minden oldalon, minden adatbetöltésnél van visszajelzés.
@Injectable({ providedIn: 'root' })
export class LoadingService {
  private count = 0;
  readonly active$ = new BehaviorSubject<boolean>(false);
  start() { this.count++; if (this.count === 1) this.active$.next(true); }
  stop() { this.count = Math.max(0, this.count - 1); if (this.count === 0) this.active$.next(false); }
}

@Injectable()
export class LoadingInterceptor implements HttpInterceptor {
  constructor(private loading: LoadingService) {}
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // Csendes kérések (pl. a betöltés-állapot saját pollja) nem jelölhetők – itt nincs ilyen,
    // de a fejlécben jelölhető: 'X-Silent'. Egyébként minden kérés számít.
    if (req.headers.has('X-Silent')) return next.handle(req);
    this.loading.start();
    return next.handle(req).pipe(finalize(() => this.loading.stop()));
  }
}
